import { SIZES, VARIANTS } from './alert-dialog.constants'

/** @type {Styles} */

export const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: 3,
    marginX: 2,
    paddingBottom: 2,
  },
  title: { marginTop: 2, typography: 'header2', color: 'gray.80', textAlign: 'center' },
  description: {
    marginTop: 1,
    textAlign: 'center',
    color: 'gray.80',
    typography: 'medium',
    marginX: 3,
  },
  headerOverride: { borderBottom: 0 },
}

export const handleStylesWithProps = ({ variant, size }) => {
  const geticonColor = () => {
    switch (variant) {
      case VARIANTS.SUCCESS:
        return 'success.main'
      case VARIANTS.NEUTRAL:
        return 'warning.light'
      default:
        return 'error.main'
    }
  }

  const geticonWrapperBackgroundColor = () => {
    switch (variant) {
      case VARIANTS.SUCCESS:
        return 'success.lightest'
      case VARIANTS.NEUTRAL:
        return 'warning.lightest'
      default:
        return 'error.lightest'
    }
  }

  return {
    dialog: (fullWidth) => ({
      width: {
        xs: fullWidth ? '100%' : SIZES.XXXS,
        sm: size,
      },
      height: 'auto',
      maxHeight: 'calc(100vh - 64px)',
      top: 'auto',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    }),
    icon: {
      color: geticonColor(),
    },
    iconWrapper: {
      backgroundColor: geticonWrapperBackgroundColor(),
      width: 48,
      height: 48,
      borderRadius: 24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }
}
